import api from "./api";
import types from "./types";
import { request } from "api/apiSaga";
import { snackbarShow } from "app/App/actions";
import trans from "helpers/trans";
import { call, put, takeLatest } from "redux-saga/effects";
import { AnyAction } from "redux";

function* destroy(action: AnyAction): any {
    const response = yield call(request, api.destroy, action, "delete");

    if (response.status === 204) {
        yield put(
            snackbarShow({
                content: trans("admin.translate.saga.content.destroy"),
            }),
        );
    }
}

function* fetch(action: AnyAction) {
    yield call(request, api.fetch, action);
}

function* get(action: AnyAction) {
    yield call(request, api.get, action);
}

function* store(action: AnyAction): any {
    const response = yield call(request, api.store, action, "post");

    if (response.status === 204) {
        yield put(
            snackbarShow({
                content: trans("admin.translate.saga.content.store"),
            }),
        );
    }
}

function* google(action: AnyAction): any {
    const response = yield call(request, api.google, action, "post");

    if (response.status === 204) {
        yield put(
            snackbarShow({
                content: trans("admin.translate.saga.content.google"),
            }),
        );
    }
}

function* toService(action: AnyAction): any {
    const response = yield call(request, api.toService, action);

    if (response.status === 202 || response.status === 204) {
        yield put(
            snackbarShow({
                content: trans("admin.translate.saga.content.toService"),
            }),
        );
    }
}

function* update(action: AnyAction): any {
    const response = yield call(request, api.update, action, "put");

    if (response.status === 204) {
        yield put(
            snackbarShow({
                content: trans("admin.translate.saga.content.update"),
            }),
        );
    }
}

function* patch(action: AnyAction): any {
    const response = yield call(request, api.patch, action, "patch");
    if (response.status === 204) {
        yield put(
            snackbarShow({
                content: trans("admin.translate.saga.content.update"),
            }),
        );
    }
    if (response.status === 422) {
        yield put(
            snackbarShow({
                content: response.data.message,
                severity: "error",
                errors: response.data.errors,
            }),
        );
    }
}

function* fetchCompare(action: AnyAction) {
    yield call(request, api.fetchCompare, action);
}

function* bulkAdd(action: AnyAction): any {
    const response = yield call(request, api.bulkAdd, action, "put");
    if (response.status === 200) {
        yield put(
            snackbarShow({
                content: trans("admin.translate.saga.content.bulkAdd"),
            }),
        );
    }
}

function* improveText(action: AnyAction): any {
    yield call(request, api.improveText, action, "post");
}

function* translate(action: AnyAction): any {
    yield call(request, api.translate, action, "get");
}

function* translateBulk(action: AnyAction): any {
    yield call(request, api.translateBulk, action, "put");
}

function* contextBulk(action: AnyAction): any {
    const response = yield call(request, api.contextBulk, action, "put");
    if (response.status === 200 || response.status === 204) {
        yield put(
            snackbarShow({
                content: "Context updated successfully.",
            }),
        );
    }
}

function* bulkImport(action: AnyAction): any {
    const response = yield call(request, api.bulkImport, action, "post");
    if (response.status === 200 || response.status === 201 || response.status === 204) {
        yield put(
            snackbarShow({
                content: "Translations imported successfully.",
            }),
        );
    }
}

export default function* saga() {
    yield takeLatest(types.DESTROY_REQUEST, destroy);
    yield takeLatest(types.FETCH_REQUEST, fetch);
    yield takeLatest(types.GET_REQUEST, get);
    yield takeLatest(types.PATCH_REQUEST, patch);
    yield takeLatest(types.TRANSLATE_GOOGLE_REQUEST, google);
    yield takeLatest(types.STORE_REQUEST, store);
    yield takeLatest(types.TRANSLATE_TO_SERVICE_REQUEST, toService);
    yield takeLatest(types.UPDATE_REQUEST, update);
    yield takeLatest(types.FETCH_COMPARE_REQUEST, fetchCompare);
    yield takeLatest(types.BULK_ADD_REQUEST, bulkAdd);
    yield takeLatest(types.BULK_IMPORT_REQUEST, bulkImport);
    yield takeLatest(types.CONTEXT_BULK_REQUEST, contextBulk);

    yield takeLatest(types.IMPROVE_TEXT_REQUEST, improveText);
    yield takeLatest(types.TRANSLATE_REQUEST, translate);
    yield takeLatest(types.TRANSLATE_BULK_REQUEST, translateBulk);
}
